import { render, staticRenderFns } from "./MapLayerControls.vue?vue&type=template&id=166ff912&"
import script from "./MapLayerControls.vue?vue&type=script&lang=js&"
export * from "./MapLayerControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports